<script>
import { pathOr, includes } from "ramda";
import {
  renderEumOptions,
  generateQueryStringWithKeysRepeat,
} from "@/shared/utils";
import { getAttachmentFiles } from "@/services";
import { mapGetters } from "vuex";

export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    hasCrop: {
      type: Boolean,
      default: false,
    },
    aspectRatio: {
      type: Number,
      default: null,
    },
    hasEditTitle: {
      type: Boolean,
      default: false,
    },
    routePath: {
      type: String,
      default: "attachment",
    },
    uploaderName: {
      type: String,
      default: null,
    },
    uploaderConfig: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      uploaderLoading: false,
      files: [],
      attachmentTypeOptions: [],
      errorMessage: "",
      attachmentTypeName: null,
      attachmentType: null,
      maxCountUpload: 1,
      isCropperModal: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    generateValidationText() {
      const acceptFormats = pathOr([], ["acceptFormats"], this.attachmentType);
      return acceptFormats
        .map(
          (item) => `${item.caption} ${this.generateSizeWithUnit(item.maxSize)}`
        )
        .join("، ");
    },
    attachmentTypeCaption() {
      return pathOr("", ["caption"], this.attachmentType);
    },
    multiple() {
      const maxCountUpload = pathOr(1, ["maxCountUpload"], this.attachmentType);
      return maxCountUpload > 1;
    },
  },
  watch: {
    userInfo: {
      immediate: true,
      handler(data) {
        if (data) {
          this.generateAttachmentTypeOptions();
        }
      },
    },
    uploaderConfig: {
      immediate: true,
      handler(data) {
        if (data) {
          this.generateAttachmentTypeOptions();
        }
      },
    },
  },
  methods: {
    pathOr,
    includes,
    renderEumOptions,
    generateQueryStringWithKeysRepeat,
    checkValidFile(file) {
      if (!file) return;
      const suffix = file.name.split(".").pop();
      const { size } = file;
      const acceptFormats = pathOr([], ["acceptFormats"], this.attachmentType);
      return acceptFormats.some((item) => {
        // convert kb to bytes
        const minSize = item.minSize * 1024;
        const maxSize = item.maxSize * 1024;

        const checkMinSize = size >= minSize;
        const checkMaxSize = size <= maxSize;

        const checkSuffix = item.suffix.length
          ? includes(suffix, item.suffix)
          : true;

        return checkMinSize && checkMaxSize && checkSuffix;
      });
    },
    generateSizeWithUnit(size) {
      // calculate and return byte size unit to output
      const units = ["کیلوبایت", "مگابایت", "گیگابایت"];
      if (!size) return `0 ${units[0]}`;
      const i = parseInt(Math.floor(Math.log(size) / Math.log(1024)));
      return Math.round(size / Math.pow(1024, i), 2) + " " + units[i];
    },
    isImage(file) {
      const imageFile = pathOr(file, ["img"], file);
      return imageFile
        ? ["png", "jpg", "jpeg"].some((item) => imageFile.type.match(item))
        : false;
    },
    changeAttachmentType(item) {
      this.attachmentType = item;
      this.maxCountUpload = pathOr(1, ["maxCountUpload"], this.attachmentType);
    },
    generateConfigData() {
      const uploaderConfig = pathOr(
        this.uploaderConfig,
        ["uploader_config"],
        this.userInfo
      );
      const attachments = pathOr(null, ["attachments"], uploaderConfig);
      const uploaders = pathOr(null, ["uploaders"], uploaderConfig);
      const uploaderItem = uploaders.find(
        (item) => item.name === this.uploaderName
      );
      const uploaderItems = pathOr([], ["items"], uploaderItem);
      const allAttachmentTypeId = attachments.filter((item) =>
        includes(item.id, uploaderItems)
      );
      return allAttachmentTypeId;
    },
    async generateAttachmentTypeOptions() {
      const configData = this.generateConfigData();
      this.maxCountUpload = pathOr(1, ["0", "max_upload"], configData);
      this.attachmentTypeName = pathOr(
        null,
        ["0", "category_name"],
        configData
      );
      const attachmentTypeOptionsId = configData.map((item) => item.id);
      const enumOptions = renderEumOptions(this.attachmentTypeName, true);
      this.attachmentTypeOptions = enumOptions
        .filter((item) => includes(item.id, attachmentTypeOptionsId))
        .map((item) => {
          const currentItem = configData.find(
            (configItem) => configItem.id === item.id
          );
          const maxCountUpload = pathOr(1, ["max_upload"], currentItem);
          const acceptFormats = pathOr([], ["types"], currentItem).map(
            (item) => {
              return {
                caption: pathOr("", ["title"], item),
                minSize: 0,
                minResolutionImage: pathOr(0, ["min_res"], item),
                maxSize: pathOr(0, ["max_size"], item),
                suffix: pathOr([], ["ext"], item),
              };
            }
          );
          return {
            ...item,
            maxCountUpload,
            acceptFormats,
          };
        });

      this.attachmentType =
        this.attachmentTypeOptions.length === 1
          ? this.attachmentTypeOptions[0]
          : null;
    },
    handleOpenCropperModal() {
      if (!this.hasCrop || this.multiple) return;
      this.isCropperModal = true;
    },
    handleCloseCropperModal() {
      this.isCropperModal = true;
    },
  },
};
</script>
